import { render, staticRenderFns } from "./ModalCarrousel.vue?vue&type=template&id=580a5fa5&scoped=true"
import script from "./ModalCarrousel.vue?vue&type=script&lang=js"
export * from "./ModalCarrousel.vue?vue&type=script&lang=js"
import style0 from "./ModalCarrousel.vue?vue&type=style&index=0&id=580a5fa5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580a5fa5",
  null
  
)

export default component.exports